import React from 'react';
import { FormButtons } from 'components-design-system'

import './preset-modal-content.scss'

const DeletePreset = ({
  setOpenModal,
  data,
  deletePreset
}) => {
  return <div className="preset-modal-content">
    <div className="actions">
      <FormButtons
        size="large"
        onCancel={() => setOpenModal(false)}
        okText="Delete"
        onOk={() => deletePreset(data)}
        okButtonProps={{
          danger: true,
        }}
      />
    </div>
  </div>
}

export default DeletePreset